var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},[React.createElement("rect",{"y":"5","width":"24","height":"2","key":0}),React.createElement("rect",{"y":"11","width":"24","height":"2","key":1}),React.createElement("rect",{"y":"17","width":"24","height":"2","key":2})]));
}

Hamburger.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Hamburger;

Hamburger.default = Hamburger;
